export default __webpack_public_path__ + "static/media/bills.78efe391.svg";